export const STORED_TO_UPGRADED_NAMESPACE = {
    axisVisualProps: 'axisProperties',
    columnVisualProps: 'columnProperties',
    dataLabelVisualProps: 'dataLabelProperties',
    legendVisualProps: 'legendProperties',
    tooltipVisualProps: 'tooltipProperties',
    displayVisualProps: 'displayProperties',
};
export const STORED_VISUAL_PROP_NAMESPACES = new Set(Object.keys(STORED_TO_UPGRADED_NAMESPACE));
//# sourceMappingURL=store-key-namespaces.js.map